import { MiddlewareInterface } from '@/middleware/middlewareInterface';
import { trackSnowplowPageView } from '@/Services/Snowplow/SnowplowService';

export default async function snowplowMiddleware({
  next,
  to,
  store,
}: MiddlewareInterface): Promise<MiddlewareInterface> {
  const page_name = to.name;
  const language_code = store.state?.auth?.user?.language;
  const user_id = store.state?.auth?.user?.id;
  const industry_id = store.state?.account?.account?.industry_id;

  trackSnowplowPageView({
    industry_id,
    page_name,
    user_id,
    language_code,
  });

  return next();
}
